import { Container, SectionTitle, Table } from '@sloyd/ui';
import { definitions } from '../../_definitions';
import { Wrapper } from './ContentProjects.style';

export type ContentProjectsProps = {
  projects: IProject[];
  isLoading: boolean;
  callbacks: {
    onAction: OnAction;
    onCta: () => void;
  };
};

export function ContentProjects(props: ContentProjectsProps) {
  const { projects, isLoading, callbacks } = props;

  return (
    <Wrapper className='ContentProjects-wrapper' data-testid='ContentProjects-wrapper'>
      <SectionTitle
        gradient={{ from: '#833ab4', to: '#fd1d1d' }}
        title='🗂️ Projects'
        cta='New Project'
        onCta={callbacks.onCta}
      />
      <Container size='md'>
        <Table
          items={projects}
          config={definitions.tables.projects}
          isLoading={isLoading}
          onAction={callbacks.onAction}
        />
      </Container>
    </Wrapper>
  );
}
